import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AccountSchema = withDefaults({
  type: 'account',
  objectExtensions: ['account'],
  fields: [
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'number',
    },
    {
      kind: 'attribute',
      name: 'deactivatedOn',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'publicOrdinalValue',
    },
    {
      kind: 'attribute',
      name: 'observation',
    },
    {
      kind: 'attribute',
      name: 'observationOverrides',
    },
    {
      kind: 'attribute',
      name: 'summary',
    },
    {
      kind: 'attribute',
      name: 'isVerified',
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'accounts',
      },
    },
    {
      kind: 'hasMany',
      name: 'loans',
      type: 'loan',
      options: {
        async: false,
        inverse: 'account',
      },
    },
    {
      kind: 'hasMany',
      name: 'matchPayments',
      type: 'match-payment',
      options: {
        async: false,
        inverse: 'account',
      },
    },
    {
      kind: 'hasMany',
      name: 'accountTransactions',
      type: 'account-transaction',
      options: {
        async: false,
        inverse: 'account',
      },
    },
    {
      kind: 'belongsTo',
      name: 'postalAddress',
      type: 'postal-address',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default AccountSchema;
